
import { Component, Vue } from "vue-property-decorator";
@Component
export default class Feature extends Vue {
  public skinTabs = [
    {
      name: "我要买",
      icon: require("@/assets/homeIcons/buy.png"),
      path: "/mywantobuy",
    },
    {
      name: "我要卖",
      icon: require("@/assets/homeIcons/sell.png"),
      path: "/wanttoSell",
    },
    {
      name: "指定我",
      icon: require("@/assets/homeIcons/assign.png"),
      path: "/appoint",
    },
    {
      name: "意见反馈",
      icon: require("@/assets/homeIcons/feedback.png"),
      path: "/Feedback",
    },
  ];
  public toPath(item) {
    if (item.name == "指定我") {
      this.$store.state.order.active = 3;
      this.$router.push(item.path);
    } else {
      this.$router.push(item.path);
    }
  }
}
